module.exports = __webpack_public_path__ + "98c79800498e557faaabd49d2fd7b428.svg";